var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTlocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40048 4.75953C7.8908 3.29902 9.89728 2.48566 11.9839 2.49619C14.0705 2.50673 16.0687 3.34032 17.5442 4.81581C19.0197 6.2913 19.8533 8.28946 19.8638 10.3761C19.8744 12.4627 19.061 14.4692 17.6005 15.9595L13.4145 20.1455C13.0394 20.5205 12.5308 20.7311 12.0005 20.7311C11.4702 20.7311 10.9615 20.5205 10.5865 20.1455L6.40048 15.9595C4.91537 14.4743 4.08105 12.4599 4.08105 10.3595C4.08105 8.25915 4.91537 6.24479 6.40048 4.75953Z",
    stroke: "#7F8983",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.3594C13.6569 13.3594 15 12.0162 15 10.3594C15 8.70252 13.6569 7.35938 12 7.35938C10.3431 7.35938 9 8.70252 9 10.3594C9 12.0162 10.3431 13.3594 12 13.3594Z",
    stroke: "#7F8983",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlocation);
export default __webpack_public_path__ + "static/media/tlocation.106df7c78dabb47fd7168a2bbd144942.svg";
export { ForwardRef as ReactComponent };